(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["nutri-taxonomy-filters"] && !Shopify.designMode) return;
  try {
    document.addEventListener('click', function (event) {
    const summary = event.target.closest('.nutri-taxonomy-inline__summary');
    if (!summary) return;

    const currentDisclosure = summary.closest('details');
    const navigation = summary.closest('.nutri-taxonomy-inline');
    if (!currentDisclosure || !navigation) return;

    navigation.querySelectorAll('details[open]').forEach(function (disclosure) {
      if (disclosure !== currentDisclosure) disclosure.removeAttribute('open');
    });
  });
  } catch(e) { console.error(e); }
})();

})();
